"use client";

import { motion } from "framer-motion";

export default function Asklocal() {
  return (
    <section className="relative flex flex-col items-center justify-center text-center  p-5  overflow-hidden">
      {/* Soft background accent circle */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 0.15, scale: 1 }}
        transition={{ duration: 1.2 }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-linear-to-tr from-[#4177BC]/40 to-[#EB9C2C]/40 rounded-full blur-3xl"
      ></motion.div>

      {/* Main Heading */}
      <motion.h1
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="relative z-10 text-transparent judson-bold  bg-clip-text uppercase font-extrabold tracking-tight leading-none 
        text-[16vw] sm:text-[12vw] md:text-[12vw]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #4177BC 10%, #EB9C2C 80%)",
        }}
      >
        ASKLOCAL
      </motion.h1>

      {/* Tagline */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        className="relative z-10 mt-6 text-gray-600 text-lg sm:text-xl inter-regular max-w-[600px]"
      >
        If your clients deserve better,{" "}
        <span className="text-[#4177BC] font-semibold">so do you.</span>
      </motion.p>

      {/* Decorative Gradient Line */}
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ delay: 0.5, duration: 1 }}
        className="relative z-10 mt-8 h-1 w-32 bg-linear-to-r from-[#4177BC] to-[#EB9C2C] origin-left rounded-full"
      ></motion.div>

      {/* Short Brand Statement */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 1 }}
        className="relative z-10 max-w-2xl mt-12 text-gray-500 text-base sm:text-lg inter-regular"
      >
        <p>
          AskLocal brings together agents, lenders, and clients on one platform
          built to simplify every step of the real estate journey. We believe in
          trust, transparency, and human connection backed by modern technology.
        </p>
      </motion.div>

      {/* Call to Action Buttons */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        className="relative z-10 mt-10 flex justify-center"
      >
        <button
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });

            setTimeout(() => {
              window.dispatchEvent(new Event("openAskLocalPartner"));
            }, 400);
          }}
          className="bg-[#4177BC] hover:bg-[#EB9C2C] text-white font-semibold px-10 py-4 rounded-full transition-all duration-300 shadow-md"
        >
          Become an AskLocal Partner
        </button>
      </motion.div>
    </section>
  );
}
